import { render, staticRenderFns } from "./PasswordNotice.vue?vue&type=template&id=384d6043&scoped=true&"
import script from "./PasswordNotice.vue?vue&type=script&lang=ts&"
export * from "./PasswordNotice.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordNotice.vue?vue&type=style&index=0&id=384d6043&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384d6043",
  null
  
)

export default component.exports